import React from 'react';
import { motion } from 'framer-motion';
import MetricsCards from './MetricsCards';
import UpcomingMedicines from './UpcomingMedicines';
import MedicineChart from './MedicineChart';
import QuickActions from './QuickActions';

const Dashboard = () => {
  return (
    <div className="p-8">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="space-y-8"
      >
        {/* Welcome Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900">Welcome back!</h1>
          <p className="text-gray-600 mt-2">Here's your medicine tracking overview for today.</p>
        </div>

        {/* Metrics Cards */}
        <MetricsCards />

        {/* Main Content Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Upcoming Medicines */}
          <div className="lg:col-span-2">
            <UpcomingMedicines />
          </div>

          {/* Quick Actions */}
          <div>
            <QuickActions />
          </div>
        </div>

        {/* Medicine Analytics Chart */}
        <MedicineChart />
      </motion.div>
    </div>
  );
};

export default Dashboard;